import styled from '@emotion/styled';
import { Divider as _Divider, Paper } from '@material-ui/core';
import { DateTime } from 'luxon';
import { ClassAttributes, createElement } from 'react';

import { SingleOfferFragment } from '../../../../graphql/generated/graphql_offer';
import { SPACING_UNIT } from '../../../constant/spacing';
import RouterLink from '../../primitive/RouterLink';
import _OfferDisplay from '../OfferDisplay';
import _OfferListItemHeader from './OfferListItemHeader';

export interface Props {
  offer: Pick<
    SingleOfferFragment,
    | 'id'
    | 'name'
    | 'jobId'
    | 'type'
    | 'matchingFormat'
    | 'organization'
    | 'availableFrom'
    | 'availableTo'
    | 'rewardAmount'
    | 'rewardCurrency'
    | 'expectedDue'
    | 'rewardQuota'
    | 'workerStatus'
    | 'assignmentCount'
    | 'candidateCount'
    | 'creativeFormats'
    | 'expressDelivery'
  >;
  currentDateTime?: DateTime;
  className?: string;
}

const OfferListItem = ({
  offer,
  currentDateTime = DateTime.local(),
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root className={className}>
      <RouterLink type="area" href={`/offers/${offer.id}`}>
        <OfferListItemHeader offer={offer} />
        <Divider />
        <OfferDisplay offer={offer} currentDateTime={currentDateTime} clickable={true} />
      </RouterLink>
    </Root>
  );
};

const Root = styled(Paper)({});

const OfferListItemHeader = styled(_OfferListItemHeader)({
  padding: `${SPACING_UNIT}px ${SPACING_UNIT * 2}px`,
  backgroundColor: '#e2e6ef',
});

const Divider = styled(_Divider)({});

const OfferDisplay = styled(_OfferDisplay)({
  padding: `${SPACING_UNIT}px ${SPACING_UNIT * 2}px`,
});

export default OfferListItem;
